// Whether this account signs in through an identity provider (Google) instead of a
// password. Such accounts have no password at all, so the reset-password funnel can do
// nothing for them — the "Reset your password" keys are hidden and the funnel says why.
//
// The authoritative signal is the boolean `IsOAuth`, which EUeInvoices.DDDI_GetMyUsers
// returns on every team-member row (confirmed on the wire: "IsOAuth": false alongside
// Active / ActivePass / UserName). Pass such a row here and the answer is exact.
//
// The string fields below are a fallback for callers that only have the session user
// (Auth.Describe), which is not confirmed to carry IsOAuth. If it carries none of these,
// this returns false and nothing is hidden — the safe direction, since a password user
// keeps their reset option either way.
// Is this team-member row the signed-in user? Shared so the team page and user settings
// can't disagree about it — they did: the team page compared UserName to the session's
// PrimaryUsername only, so when those two differ for an account it found no row of its own
// and showed no reset key at all, while user settings matched the same account by Id and
// showed one. Id is the reliable comparison; the other two are fallbacks for callers whose
// row or session is missing it.
export const isOwnUser = (user, sessionUser) => {
    if (!user || !sessionUser) return false;
    const same = (a, b) => !!a && !!b && String(a).toLowerCase() === String(b).toLowerCase();
    return same(user.Id, sessionUser.Id)
        || same(user.UserName, sessionUser.PrimaryUsername)
        || same(user.Email, sessionUser.Email);
};

const OAUTH_VALUES = ["google", "oauth"];

export const isOAuthAccount = (user) => {
    if (!user) return false;
    if (typeof user.IsOAuth === "boolean") return user.IsOAuth;
    const candidates = [
        user.AuthProvider,
        user.AccountSource,
        user.Provider,
        user.AuthenticationDetails?.AuthProvider,
        user.AuthenticationDetails?.AccountSource,
    ];
    return candidates.some((value) =>
        typeof value === "string" && OAUTH_VALUES.includes(value.trim().toLowerCase())
    );
};
